import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 17,
  steps: [
    addColumns({
      table: 'chats',
      columns: [{ name: 'ia_ai_session', type: 'boolean' }]
    })
  ]
}
